import React, { ReactNode, FC, useState, useMemo } from 'react';
import { GenerateResponseContext } from './context';
import { TenjinSettingsRequest } from './types';

interface Props {
  children: ReactNode;
}

export const GenerateResponseProvider: FC<Props> = ({ children }) => {
  const [settings, setSettings] = useState<TenjinSettingsRequest | undefined>(undefined);

  const contextValue = useMemo(() => ({ settings, setSettings }), [settings, setSettings]);
  return <GenerateResponseContext.Provider value={contextValue}>{children}</GenerateResponseContext.Provider>;
};
